import { getAlpha2WithExceptions } from '@/components/Checkout/_helpers/functions/getAlpha2WithExceptions'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  market: Alpha2CountryCode
  cardName: string
  hydraToken: string
}

export const HydraRemoveCreditCard = async ({
  market,
  cardName,
  hydraToken,
}: Props) => {
  const request: SendRequestType = {
    method: 'DELETE',
    url: `/customers/me/creditcardaliases/${getAlpha2WithExceptions({
      alpha2: market,
    })}/${cardName}`,
    token: hydraToken,
  }

  return httpTools.sendRequest(request)
}
